const ingredients = ()=>({
    selectedItem: null,
    openDrawer: false,
    selectedFilter: "View all",
    otherIngredientsDrawerIsOpen: false,
    init(){

    },
    closeDrawer(){
        this.openDrawer = false
        setTimeout(()=>{
            this.selectedItem = null
        }, 200)
        document.body.classList.remove('overflow-hidden');
    },
    selectIngredient({image, title, description, filter, url}){
        this.openDrawer = false
        this.selectedItem = {image, title, description, filter, url}
        if (this.selectedItem){
            setTimeout(()=>{
                this.openDrawer = true
            }, 200)
        }
        document.body.classList.add('overflow-hidden');
    },
    filteringIngredients(filterName){
        this.selectedFilter = filterName
    },
    toggleOtherIngredientsDrawer(){
        this.otherIngredientsDrawerIsOpen = !this.otherIngredientsDrawerIsOpen
        document.body.classList.toggle('overflow-hidden');
    },

})

export default ingredients